// extracted by mini-css-extract-plugin
export default {"content_div":"Home_content_div__J6LY-","content":"Home_content__UTess"};